import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useInitBranchCodding = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getManualInsertDefaults = (profileGuid, callback) => {
    setLoading(true);

    axiosClient
      .get(`Product/Branch/Codding/Manual/insert`, {
        params: { GUID: profileGuid },
      })
      .then(res => {
        if (res.status === 200) {
          setData(res.data.value);
          if (callback) {
            callback(res.data.value);
          }
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getManualInsertDefaults, loading, data];
};

export default useInitBranchCodding;
